import { createContext } from 'react';

import { UsersRoleDto } from '../generated/tellus';

export interface UserContextProps {
  id: string;
  email: string;
  phonenumber: string;
  name: string;
  companyKey?: string | null;
  roles: UsersRoleDto[];
  updateUser: () => void;
}

export const UserContext = createContext<UserContextProps | undefined>(
  undefined
);
UserContext.displayName = 'UserContext';
